'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _LinkOutlined = _interopRequireDefault(require('./lib/icons/LinkOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _LinkOutlined;
  exports.default = _default;
  module.exports = _default;